module.exports = __webpack_public_path__ + "static/media/close.caf94742.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/close.svg
// module id = 173
// module chunks = 0